<template>
  <div class="_ipbookingform__wrapper--header">
    <keep-alive>
      <component :is="currentHeader" :header="bookingData"></component>
    </keep-alive>
  </div>
</template>

<script>
import InfoHeaderRFQ from '@/components/requestList/requestStatusRFQ/InfoHeader'
import InfoHeaderContract from '@/components/requestList/requestStatusContract/InfoHeader'
import InfoHeaderIQ from '@/components/requestList/requestStatusIQ/InfoHeader'
import InfoHeaderIP from '@/components/instantPrice/InfoHeader'

export default {
  name: 'infoHeaderBookingForm',
  components: {
    InfoHeaderRFQ,
    InfoHeaderContract,
    InfoHeaderIQ,
    InfoHeaderIP
  },
  props: {
    shipmentType: String,
    bookingData: Object
  },
  computed: {
    currentHeader () {
      let header = ''
      if (this.shipmentType === 'rfq') {
        header = InfoHeaderRFQ
      } else if (this.shipmentType === 'contract') {
        header = InfoHeaderContract
      } else if (this.shipmentType === 'iq') {
        header = InfoHeaderIQ
      } else if (this.shipmentType === 'instant-price') {
        header = InfoHeaderIP
      }
      return header
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/bookingForm/InfoHeader.vue